import { useContext } from 'react';
import { TransportContext } from '../providers/transport-provider';
const useTransport = () => {
    const transport = useContext(TransportContext);
    return { transport };
};
export { useTransport };
//# sourceMappingURL=use-transport.js.map